<template>
  <v-card-text>
    <v-subheader>基本信息</v-subheader>
    <!-- 供应商名称 -->
    <v-text-field
      ref="name"
      v-model="name"
      :rules="[() => !!name || '供应商名称不能为空']"
      label="供应商名称"
      required
      outlined
      clearable
    >
      <template v-slot:prepend>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-help-circle-outline</v-icon>
          </template>
          这是供应商名称的提示消息
        </v-tooltip>
      </template>
    </v-text-field>

    <!-- 供应商地址 -->
    <v-text-field
      ref="address"
      v-model="address"
      :rules="[() => !!address || '供应商地址不能为空']"
      label="供应商地址"
      required
      outlined
      clearable
    >
      <template v-slot:prepend>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-help-circle-outline</v-icon>
          </template>
          这是供应商地址的提示消息
        </v-tooltip>
      </template>
    </v-text-field>
    <v-divider></v-divider>

    <!-- 供应商类型 -->
    <v-subheader>供应能力</v-subheader>
    <v-subheader style="font-size: 20px">供应商类型</v-subheader>
    <v-row justify="space-around">
      <v-checkbox color="success" v-model="type.factoryDirectSales" label="厂家直销"></v-checkbox>
      <v-checkbox color="success" v-model="type.agent" label="代理商"></v-checkbox>
      <v-checkbox color="success" v-model="type.retail" label="零售商"></v-checkbox>
      <v-checkbox color="success" v-model="type.store" label="实体店"></v-checkbox>
      <v-checkbox color="success" v-model="type.webStore" label="网络商店"></v-checkbox>
    </v-row>

    <!-- 供应情况说明 -->
    <v-textarea outlined name="input-7-4" label="供应商情况说明" v-model="description">
      <template v-slot:prepend>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-help-circle-outline</v-icon>
          </template>
          这是供应情况说明的提示消息
        </v-tooltip>
      </template>
    </v-textarea>
    <v-divider></v-divider>

    <v-subheader>联系方式</v-subheader>
    <!-- 电子邮箱 -->
    <v-text-field
      ref="email"
      v-model="email"
      :rules="[rules.required, rules.email]"
      label="电子邮箱地址"
      required
      outlined
      clearable
    >
      <template v-slot:prepend>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-help-circle-outline</v-icon>
          </template>
          这是电子邮箱的提示消息
        </v-tooltip>
      </template>
    </v-text-field>

    <!-- 联系人 -->
    <v-text-field
      ref="peopleName"
      v-model="peopleName"
      :rules="[() => !!peopleName || '联系人不能为空']"
      label="联系人"
      required
      outlined
      clearable
    >
      <template v-slot:prepend>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-help-circle-outline</v-icon>
          </template>
          这是联系人的提示消息
        </v-tooltip>
      </template>
    </v-text-field>

    <!-- 联系电话 -->
    <v-text-field
      ref="phoneNumber"
      v-model="phoneNumber"
      :rules="[() => !!phoneNumber || '联系电话不能为空']"
      label="联系电话"
      required
      outlined
      clearable
    >
      <template v-slot:prepend>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-help-circle-outline</v-icon>
          </template>
          这是联系电话的提示消息
        </v-tooltip>
      </template>
    </v-text-field>

    <!-- 传真 -->
    <v-text-field ref="fax" v-model="fax" label="传真" outlined clearable>
      <template v-slot:prepend>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-help-circle-outline</v-icon>
          </template>
          这是传真的提示消息
        </v-tooltip>
      </template>
    </v-text-field>

    <!-- 通信地址 -->
    <v-text-field
      ref="phoneAddress"
      v-model="phoneAddress"
      :rules="[() => !!phoneAddress || '通信地址不能为空']"
      label="通信地址"
      outlined
      clearable
    >
      <template v-slot:prepend>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-help-circle-outline</v-icon>
          </template>
          这是通信地址的提示消息
        </v-tooltip>
      </template>
    </v-text-field>
    <v-divider></v-divider>

    <v-subheader>合作意向</v-subheader>
    <!-- 合作品类 -->
    <v-text-field
      ref="coOperatives"
      v-model="coOperatives"
      :rules="[() => !!coOperatives || '合作品类不能为空']"
      label="合作品类"
      outlined
      clearable
    >
      <template v-slot:prepend>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-help-circle-outline</v-icon>
          </template>
          这是合作品类的提示消息
        </v-tooltip>
      </template>
    </v-text-field>

    <!-- 合作方式 -->
    <v-text-field
      ref="workTogetherType"
      v-model="workTogetherType"
      :rules="[() => !!workTogetherType || '合作方式不能为空']"
      label="合作方式"
      outlined
      clearable
    >
      <template v-slot:prepend>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-help-circle-outline</v-icon>
          </template>
          这是合作方式的提示消息
        </v-tooltip>
      </template>
    </v-text-field>

    <!-- 合作意向描述 -->
    <v-textarea outlined name="input-7-4" label="合作意向描述" v-model="workTogetherDescription">
      <template v-slot:prepend>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-help-circle-outline</v-icon>
          </template>
          这是合作意向描述的提示消息
        </v-tooltip>
      </template>
    </v-textarea>
  </v-card-text>
</template>

<script>
export default {
  data: () => {
    return {
      name: "",
      address: "",
      type: {
        factoryDirectSales: false,
        agent: false,
        retail: false,
        store: false,
        webStore: false
      },
      description: "",
      email: "",
      peopleName: "",
      phoneNumber: "",
      fax: "",
      phoneAddress: "",
      coOperatives: "",
      workTogetherType: "",
      workTogetherDescription: "",
      rules: {
        // 表单验证对象
        required: value => !!value || "不能为空",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "邮箱地址格式不正确";
        }
      }
    };
  },
  methods: {}
};
</script>

<style>
</style>